var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mb-12 text-center"},[_c('h1',{staticClass:"font-weight-light mb-2",staticStyle:{"color":"#3c4858","font-size":"24px"},domProps:{"textContent":_vm._s(`${_vm.CONF_CLIENT} - ${_vm.heading}`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }